'use strict';

/* Controllers */

app.controller('MoneyReceiptController', ['$scope', '$rootScope', '$location', '$timeout', 'Cart', 'Router', 'User', 
    function ($scope, $rootScope, $location, $timeout, Cart, Router, User) {

        // pass service to scope
        $scope.User = User;

    	// init scope vars
    	$scope.selectedUser    = $rootScope.globals.selectedUser;
        $scope.currency_symbol = $rootScope.globals.currentUser.credit.symbol;

    	$scope.money_amount    = $rootScope.globals.selectedMoney.amount;


        /**
         * clear cart and redirect home
         */
        $scope.returnHome = function(){
            $timeout(function(){
                Cart.clearCart();
            }, 100);
            
            $location.path('/');
        }

    }]);